import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

interface CurrencySelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  setPopperRef: (node: HTMLDivElement | null) => void;
}

const currencies = [
  { code: 'USD', name: 'US Dollar' },
  { code: 'EUR', name: 'Euro' },
  { code: 'GBP', name: 'British Pound' },
  { code: 'CAD', name: 'Canadian Dollar' },
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'CHF', name: 'Swiss Franc' },
];

export default function CurrencySelector({
  value,
  onChange,
  disabled,
  setPopperRef,
}: CurrencySelectorProps) {
  const { t } = useTranslation();
  const id = uuidv4();

  return (
    <TextField
      sx={{
        '& .Mui-disabled:hover fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.23) !important', // Default disabled border color
        },
      }}
      select
      fullWidth
      variant='outlined'
      label={t('formInputs.currencyInputLabel')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      slotProps={{ inputLabel: { htmlFor: id }, input: { id } }}
      SelectProps={{
        MenuProps: {
          ref: setPopperRef, // Callback ref para manejar la referencia del menú desplegable
        },
      }}
    >
      {currencies.map((currency) => (
        <MenuItem key={currency.code} value={currency.code}>
          {currency.name} ({currency.code})
        </MenuItem>
      ))}
    </TextField>
  );
}
